<div class="listing-grid">

    <div class="row">
        <div class="col-12">
            <h2>Market Analysis</h2>

            <div class="ma-data" *ngIf="data">
                <div class="market_analysis_ui" *ngFor="let eItem of data?.events;trackBy:trackByIndex;">
                    <h4 routerLink="/event/detail/{{eItem.event_id}}">{{eItem.event_name}}</h4>
                    <table class="table table-bordered" *ngFor="let mItem of eItem?.data;trackBy:trackByIndex;">
                        <thead>
                            <tr>
                                <th colspan="2">{{mItem?.market_type_id.replace('_',' ')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of mItem?.market_data;trackBy:trackByIndex;">
                                <td>{{item?.market_type_id == "FANCY" ? item?.fancy_name : item?.market_type_id == "BOOK_MAKER" ? item?.bookmaker_runner_name : item?.runner_name }}</td>
                                <td [ngClass]="{'text-green' : item?.expose > 0, 'text-red' : item?.expose < 0}"> {{item?.expose}} </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <div class="row" *ngFor="let mItem of eItem?.data;trackBy:trackByIndex;">
                        <p>{{mItem?.data[0]?.market_type_id}}</p>
                        <div class="col-6" *ngFor="let item of mItem?.data;trackBy:trackByIndex;">
                            <span>{{item?.market_type_id == "FANCY" ? item?.fancy_name : item?.market_type_id == "BOOK_MAKER" ? item?.bookmaker_runner_name : item?.runner_name }}</span>
                            <span [ngClass]="{'text-green' : item?.expose > 0, 'text-red' : item?.expose < 0}"> {{item?.expose}} </span>
                        </div>
                    </div> -->
                </div>

                <div *ngIf="data?.events.length == 0" style="display: flex;justify-content: center;"> <h4>No Data To Display</h4></div>
            </div>
        </div>
    </div>
</div>